import(/* webpackMode: "eager" */ "/home/coder/pubky-app-cards-shots/src/app/global-error.tsx");
